import { useEffect, useRef, useState } from 'react';

import { toast } from 'sonner';

import { unlockAccount } from '../api/unlock-account';

export type UnlockStatus = 'unlocking' | 'unlocked' | 'invalid';

export function useUnlockOnMount(token: string): UnlockStatus {
    const [status, setStatus] = useState<UnlockStatus>('unlocking');
    // Tracks the last token consumed so the request fires once per distinct token — this both
    // skips StrictMode's double-invoke and re-runs if the token prop changes without a remount.
    const lastTokenRef = useRef<string | null>(null);

    useEffect(() => {
        if (lastTokenRef.current === token) return;
        lastTokenRef.current = token;

        setStatus('unlocking');

        void (async () => {
            const result = await unlockAccount(token);
            if (result.ok) {
                setStatus('unlocked');
                // Copy from Figma 2438-1697, shared with the cooldown-finish toast.
                toast.success('Your account has been unlocked!');
                return;
            }
            setStatus('invalid');
        })();
    }, [token]);

    return status;
}
